module.exports = __webpack_public_path__ + "img/jarom-vogel-powerful-stuff.43a128f.jpg";